module.exports = __webpack_public_path__ + "img/Toyota.f310aec2.jpg";